import { useEffect, useRef, useState } from 'react';
import { useVoiceDemo } from '../../providers/VoiceDemoContext';
import { ChevronDown } from '../icons/ChevronDown';

const speedList = [0.75, 1, 1.25, 1.5, 1.75, 2];

export function ProsodyInput() {
  const { prosody, handleUpdateProsody } = useVoiceDemo();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };
    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isDropdownOpen]);

  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);
  return (
    <div className="relative w-full" ref={dropdownRef}>
      <button
        key={prosody.rate}
        className={`flex w-full cursor-pointer items-center justify-between rounded-2xl border-[1px] px-[16px] py-[14px] leading-5 hover:bg-[#F5F5FA] @sm:gap-2 ${isDropdownOpen ? 'border-[#9899A6]' : 'border-[#E9EAF0]'}`}
        onClick={toggleDropdown}>
        <div className="text-[1rem]">Speed: {prosody.rate}x</div>
        <ChevronDown />
      </button>
      {isDropdownOpen && (
        <div className="dropdown-shadow absolute top-[56px] z-50 flex min-w-[100%] flex-col justify-center gap-1 overflow-y-auto rounded-2xl border-[1px] border-[#E9EAF0] bg-white p-2 no-scrollbar">
          {speedList.map((speed, idx) => {
            return (
              <button
                key={speed}
                className="min-w-[100%] rounded-2xl px-4 py-2 hover:bg-[#E9EAF0]"
                onClick={() => {
                  setIsDropdownOpen(false);
                  handleUpdateProsody({ ...prosody, rate: speedList[idx] });
                }}>
                {speed}x
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
